import React, { Component } from 'react'; //different
import instance from "./axios-instance";
import Swal from 'sweetalert2'
import Systems from "./SystemFunction";
import moment from 'moment';
class App extends Component {
    get lang() { return localStorage.getItem('lang') || 'th'; }
    constructor(props) {
        super(props)
        this.state = {
            weekdays: [],
            userid: props.userid,   // only pick what you need
            weeksum: [],
            username: '',
            firstname: '',
            clicked: false,
            lastname: '',
            checkinsetting: [],
            checkinThisMonth: 0,
        }
        this.MILESTONES = [
            { days: 0, percent: 0 },
            { days: 3, percent: 25 },
            { days: 7, percent: 50 },
            { days: 15, percent: 75 },
            { days: 25, percent: 100 },
        ];
    }

    handleNav(to, e = { preventDefault: () => { } }) {
        // ถ้า e ถูกส่งมาจาก onClick ปกติ
        if (e?.preventDefault) e.preventDefault();

        // รองรับ ctrl / alt / middle click
        if (e?.metaKey || e?.ctrlKey || e?.shiftKey || e?.altKey || e?.button === 1) return;

        console.log("📍 Navigate to:", to);

        if (typeof this.props.onNavigate === "function") {
            this.props.onNavigate(to, e);
        } else {
            // fallback
            window.history.pushState(null, "", to);
            window.dispatchEvent(new PopStateEvent("popstate"));
        }
    }
    async componentDidMount() {
        console.log("componentDidMount Cardgame prevState", this.props);
        this.getcheckin(this.props.userid);

    }
    componentDidUpdate(prevProps, prevState) {
        const { point, userid } = this.props; // destructuring for easier access

        // Check if point has changed
        if (prevProps.point !== point) {
            if (point !== this.state.point) {
                console.log("componentDidUpdate - point updated:", point);
                this.setState({ point });
            }
        }

        // Check if username has changed
        if (prevProps.username !== userid) {
            if (userid !== this.state.userid) {
                console.log("componentDidUpdate - username updated:", userid);
                this.setState({ userid: userid });
                this.getcheckin(this.props.userid);
            }
        }
    }


    handleCheckIn = async (item, type) => {
        console.log('Check-in item clicked:', item, type);
        this.setState({ clicked: true })

        try {
            // สร้างข้อมูลใน object.rows ที่จำเป็น
            if (type === 1) {
                const isToday = moment().isSame(moment(item.dateStr), 'day'); // เช็คว่าเป็นวันนี้
                if (isToday) {
                    const rows = {
                        userid: this.state.userid,  // user ID ที่เช็คอิน
                        dateupdate: item.dateStr,
                        CheckinID: item.weekdayIndex,
                        status: 1,  // สถานะการเช็คอิน
                        // คุณสามารถเพิ่มข้อมูลเพิ่มเติมได้ตามที่ต้องการ
                    };

                    // ส่งข้อมูลไปยัง API
                    const response = await instance.post('/api/v1/postcheckinlist', {
                        System: Systems,
                        type: type,
                        userid: this.state.userid,  // user ID ที่เช็คอิน
                        rows: rows,
                    });

                    const data = await response.data; // ใช้ .data แทน .json() ถ้าใช้ axios
                    if (data.status === 200) {
                        Swal.fire({
                            icon: 'success',
                            title: 'เช็คอินสำเร็จ',
                            showConfirmButton: false,
                            timer: 1500,
                        });
                    }

                    else {
                        console.log('Check-in failed:', data);
                        await Swal.fire({
                            icon: 'warning',
                            title: 'เช็คอินไม่สำเร็จ',
                            text: data.message,
                        });
                        this.setState({ clicked: false })
                    }
                } else {
                    console.log('ไม่สามารถเช็คอินสำหรับวันที่นี้');
                    Swal.fire({
                        icon: 'error',
                        title: 'ไม่สามารถเช็คอินได้',
                        text: 'วันที่เช็คอินไม่ตรงกับวันนี้',
                    });
                }
            } else if (type === 2) {
                // ส่งข้อมูลไปยัง API สำหรับการรับรางวัลสะสม
                const response = await instance.post('/api/v1/postcheckinlist', {
                    System: Systems,
                    userid: this.state.userid,  // user ID ที่เช็คอิน
                    item: item,
                    type: type,
                    status: 1,  // สถานะการเช็คอิน
                });

                const data = await response.data; // ใช้ .data แทน .json() ถ้าใช้ axios
                if (data.status === 200) {
                    Swal.fire({
                        icon: 'success',
                        title: 'รับรางวัลสะสมสำเร็จ',
                        showConfirmButton: false,
                        timer: 1500,
                    });
                } else {
                    console.log('Reward redemption failed:', data);
                    Swal.fire({
                        icon: 'warning',
                        title: 'รับรางวัลไม่สำเร็จ',
                        text: data.message,
                    });
                }
            }
        }
        catch (error) {
            console.log('Error posting checkin:', error);
            Swal.fire({
                icon: 'error',
                title: 'เกิดข้อผิดพลาดในการเช็คอิน',
                text: error.message || 'กรุณาลองใหม่อีกครั้ง',
            });
        }
        this.getcheckin(this.state.userid); // ดึงข้อมูลการเช็คอินล่าสุด
    };

    getcheckin = async (username) => {
        try {
            await instance.post("/api/v1/getcheckin", {
                System: Systems,
                userid: username,
            }).then(async (res) => {
                console.log("getcheckin", res.data)



                if (res.data.status === 200) {
                    const datas = res.data;

                    if (datas.tblcheckinsetting.length > 0 && datas.tblcheckinsetting[0].status == 0) {
                        await Swal.fire({
                            icon: 'error',
                            title: 'เกมยังไม่เปิดให้บริการ',
                            showConfirmButton: true,
                            confirmButtonText: 'ตกลง'
                        });
                        this.handleNav('/event')
                    }
                    this.setState({
                        checkinThisMonth: datas.checkinThisMonth,
                        weekdays: datas.weekList.week,
                        weeksum: datas.weekList.weeksum,
                        checkinsetting: datas.tblcheckinsetting,
                    });

                }
                else {
                    // this.CheckThisGoalError();
                }
            });
        }
        catch (error) {
            console.log(error)
        }
    }

    getPercentByDays(days) {
        const d = Number(days || 0);
        if (d <= 0) return 0;
        if (d >= 25) return 100;

        // หา segment ที่ days อยู่ระหว่าง point i และ i+1
        for (let i = 0; i < this.MILESTONES.length - 1; i++) {
            const a = this.MILESTONES[i];
            const b = this.MILESTONES[i + 1];
            if (d >= a.days && d <= b.days) {
                // linear interpolation
                const ratio = (d - a.days) / (b.days - a.days);
                const pct = a.percent + ratio * (b.percent - a.percent);
                return Math.round(pct * 100) / 100; // ปัด 2 ตำแหน่ง
            }
        }
        return 100;
    }

    getNearestMilestone(days) {
        const d = Number(days || 0);
        let last = this.MILESTONES[0];
        for (const m of this.MILESTONES) {
            if (d >= m.days) last = m;
            else break;
        }
        return last; // คืน object {days, percent}
    }
    render() {
        const { checkinThisMonth, weeksum, checkinsetting } = this.state;

        // สิ่งที่ควรใช้เป็น totalNeeded (ถ้าจาก setting ให้ดึงจาก checkinsetting หรือ weeksum)
        const current = Number(this.state.checkinThisMonth || 0);
        const percent = this.getPercentByDays(current);
        const nearest = this.getNearestMilestone(current);

        return (
            <div style={{ background: '#1E1E1E', minHeight: '100%', paddingBottom: 120 }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', height: 48, padding: '0 16px', color: '#FBDEB2' }}>
                    <span role="button" onClick={() => this.handleNav('/home')} style={{ cursor: 'pointer', fontSize: 22 }}>&#8249;</span>
                    <span style={{ fontSize: 14 }}>กิจกรรมเชคอิน</span>
                    <span style={{ width: 16 }} />
                </div>
                <div style={{ margin: '8px 16px 0', borderRadius: 16, padding: '20px 18px', textAlign: 'center', background: 'linear-gradient(135deg, #4a3a1f 0%, #2a2114 60%, #1a140c 100%)', border: '1px solid #8A7349' }}>
                    <div style={{ color: '#FBDEB2', fontSize: 22, fontWeight: 700 }}>เช็คอินประจำวัน</div>
                    <div style={{ color: '#ECCA77', fontSize: 13, marginTop: 6 }}>ทำยอดเติม {checkinsetting[0]?.credit || 0}.- ขึ้นไป</div>
                    <div style={{ color: '#CDCDCD', fontSize: 12, marginTop: 6, lineHeight: 1.5 }}>รับทุกวันเพียงเข้ามาเช็คอิน พร้อมทั้งสะสมเพื่อรับรางวัลที่สูงขึ้น</div>
                </div>
                <div style={{ marginTop: 18 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '0 16px', color: '#FBDEB2', fontSize: 14, fontWeight: 600, marginBottom: 10 }}>
                        <i className="fas fa-calendar-check" /> เช็คอินประจำวัน
                    </div>
                    <div style={{ display: 'flex', gap: 10, overflowX: 'auto', padding: '0 16px 6px' }}>
                        {this.state.weekdays.map((item, index) => {
                            const m = moment(item.dateStr);
                            const isPast = m.isBefore(moment(), 'day');
                            const isToday = m.isSame(moment(), 'day');
                            const claimable = isToday && !item.passed && !this.state.clicked;
                            return (
                                <button key={item.dateStr || index}
                                    onClick={() => claimable ? this.handleCheckIn(item, 1) : null}
                                    disabled={!claimable}
                                    style={{ flex: '0 0 auto', width: 72, borderRadius: 12, padding: '10px 6px', background: item.passed ? '#1e3a2e' : isToday ? '#2a2114' : '#262626', border: `1px solid ${item.passed ? '#22c55e' : isToday ? '#ECCA77' : '#3a3a3a'}`, opacity: (isPast && !item.passed) ? 0.5 : 1, cursor: claimable ? 'pointer' : 'default', textAlign: 'center' }}>
                                    <img alt="coin" style={{ width: 40, height: 40, objectFit: 'contain' }} src={item.passed ? 'https://asset.cloudigame.co/build/admin/img/wt_theme/ezl/check-in-checked.png' : 'https://asset.cloudigame.co/build/admin/img/wt_theme/ezl/check-in-coin.png'} />
                                    <div style={{ color: '#FBDEB2', fontSize: 12, fontWeight: 700, marginTop: 2 }}>+{item.credit}</div>
                                    <div style={{ color: '#CDCDCD', fontSize: 11, marginTop: 2 }}>{isToday ? 'วันนี้' : m.format('DD/MM')}</div>
                                </button>
                            );
                        })}
                    </div>
                </div>
                <div style={{ margin: '18px 16px 0', borderRadius: 16, padding: 16, background: '#1f1f1f', border: '1px solid #3a3a3a' }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
                        <span style={{ color: '#FBDEB2', fontSize: 14, fontWeight: 600 }}>เช็คอินสะสมเดือนนี้</span>
                        <span style={{ color: '#FBDEB2', fontSize: 13 }}><b style={{ fontSize: 18 }}>{checkinThisMonth}</b> วัน</span>
                    </div>
                    <div style={{ display: 'flex', gap: 10, overflowX: 'auto', paddingBottom: 6 }}>
                        {weeksum.map((item, index) => {
                            const claimable = item.passed && item.totalday <= checkinThisMonth && !this.state.clicked;
                            return (
                                <div key={index} onClick={() => claimable ? this.handleCheckIn(item, 2) : null}
                                    style={{ flex: '0 0 auto', width: 90, borderRadius: 12, padding: '10px 6px', textAlign: 'center', background: claimable ? '#1e3a2e' : '#262626', border: `1px solid ${claimable ? '#22c55e' : '#3a3a3a'}`, opacity: (item.totalday > checkinThisMonth) ? 0.6 : 1, cursor: claimable ? 'pointer' : 'default' }}>
                                    <img alt="box" style={{ width: 54, height: 54, objectFit: 'contain' }} src="https://asset.cloudigame.co/build/admin/img/wt_theme/ezl/check-in-box.png" />
                                    <div style={{ color: '#fbbf24', fontSize: 12, fontWeight: 600 }}>สูงสุด {item.credit}฿</div>
                                    <div style={{ color: '#CDCDCD', fontSize: 11, marginTop: 2 }}>{item.totalday} วัน</div>
                                </div>
                            );
                        })}
                    </div>
                    <div style={{ marginTop: 14 }}>
                        <div style={{ color: '#FBDEB2', fontSize: 12, marginBottom: 6 }}>{current}/25</div>
                        <div style={{ background: '#374151', borderRadius: 99, height: 8, overflow: 'hidden' }}>
                            <div style={{ background: 'linear-gradient(90deg, #f59e0b, #fbbf24)', height: '100%', width: `${percent}%`, borderRadius: 99 }} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default App;
